import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useVpsMetrics = () => {
  return useQuery({
    queryKey: ['vps-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('vps_metrics')
        .select('*')
        .order('created_at', { ascending: true })
        .limit(50);

      if (error) throw error;
      return data;
    },
    refetchInterval: 5000
  });
};